import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VendorPermissionsResult, VendorPermissionSave, VendorLayout } from '../models/vendor-contact-permission';

@Injectable({
  providedIn: 'root'
})
export class VendorPermissionService {

  baseUrl = environment.apiEndpoint + '/partner';

  constructor(private http: HttpClient) { }

  // All grants on a project (internal view): per-contact grants plus per-vendor "all contacts" state.
  getProjectVendorPermissions(projectId: string): Observable<VendorPermissionsResult> {
    return this.http.get<VendorPermissionsResult>(`${this.baseUrl}/vendorpermissions/${projectId}`);
  }

  // Full replace of a project's grants (Super Admin / MST only, enforced server-side).
  saveProjectVendorPermissions(projectId: string, payload: VendorPermissionSave): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/vendorpermissions/${projectId}`, payload);
  }

  // Permission keys granted to the logged-in vendor's own contact on this project.
  getMyVendorPermissions(projectId: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/myvendorpermissions/${projectId}`);
  }

  // NK-263: the Decipher layouts the logged-in vendor is allowed to download on this project.
  getMyAllowedLayouts(projectId: string): Observable<VendorLayout[]> {
    return this.http.get<VendorLayout[]>(`${this.baseUrl}/myvendorlayouts/${projectId}`);
  }
}
